import React, { useState, useEffect } from 'react';
import { Grid } from '@mui/material';
import { useDispatch } from 'react-redux';
import RepQuotaPanel from './RepQuotaPanel';
import { fetchQuotaData, getTeamAndFiscalQuarters } from './redux/management.thunk';
import { clearManagementSlice } from './redux/management.slice';
import AddQuotaForReps from './QuotaManagement/AddQuotaForReps';
import QuotaRemoval from './QuotaManagement/QuotaRemoval';
import AddHeaderDescriptionWithHelperText from "../../components/HelperTextDescription";
import UpdateFiscalQuarterFilter from './components/UpdateFiscalQuarterFilter';
import QuotaManagementToggle from './components/QuotaManagementToggle';

const RepManagementContainer = () => {
  const [view, setView] = useState('add');
  const [touched, setTouched] = useState(false);
  const dispatch = useDispatch();

  const headerText = "Rep Quota Management";
  const descriptionText = "Add / Delete / Update Quota for Reps";

  useEffect(() => {
    dispatch(getTeamAndFiscalQuarters({ type: 'rep' }));

    return () => {
      dispatch(clearManagementSlice());
    };
  }, [dispatch]);

  const handleChangeView = (event, newView) => {
    if (newView !== null) {
      if (touched) {
        if (window.confirm("You have unsaved changes. Do you want to discard and switch view?")) {
          setView(newView);
          setTouched(false);
        }
      } else {
        setView(newView);
      }
    }
  };

  const toggleButtonStyle = (buttonView) => ({
    background: view === buttonView ? "#4472C4" : "",
    color: view === buttonView ? "white" : "",
    fontSize: "1rem",
    fontWeight: 600,
    height: "3.5rem",
    width: "14rem",
  });

  return (
    <Grid container spacing={2}>
      <Grid container item style={{ margin: "1rem 0rem" }}>
        <AddHeaderDescriptionWithHelperText
          header={headerText}
          description={descriptionText}
        />
      </Grid>
      <Grid item xs={12}>
        <QuotaManagementToggle
          section="Rep"
          view={view}
          handleChangeView={handleChangeView}
          toggleButtonStyle={toggleButtonStyle}
        />
      </Grid>
      <Grid item xs={12}>
        {view === 'add' && <AddQuotaForReps />}
        {view === 'remove' && <QuotaRemoval />}
        {view === 'update' && (
          <>
            <Grid item xs={12}>
              <UpdateFiscalQuarterFilter touched={touched} setTouched={setTouched} fetchData={fetchQuotaData} type="rep" />
            </Grid>
            <RepQuotaPanel setTouched={setTouched} />
          </>
        )}
      </Grid>
    </Grid>
  );
};

export default RepManagementContainer;
